import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { Alert, Form, Row, Col, Button } from 'react-bootstrap';
import { Input, FormActions, DateTimeInput, FormFileUpload, Select } from '../../common/components/formControls';
import validators from '../../common/services/validators';
import { withTranslation } from 'react-i18next';

const SettingsForm = ({ error, handleSubmit, pristine, submitting, isReadonly, submitSucceeded, t, initialValues }) => {

	const isPaidOptions = (t) => {
		return [
			{ id: 'false', name: t('Common_No') },
			{ id: 'true', name: t('Common_Yes') }
		]
	};

	const documentData = initialValues && initialValues.document && {
		filename: initialValues.document.filename,
		url: initialValues.document.url
	};

	return (
		<Form onSubmit={handleSubmit}>
			{error && <Alert bsStyle='danger'>{error}</Alert>}
			{submitSucceeded && pristine && <Alert bsStyle='success'>{t('Common_UpdateSuccess')}</Alert>}
			<Row>
				<Col sm={6}>
					<Field name='paymentDate' component={DateTimeInput} type='text' disabled={isReadonly} showTime={false} label={t('KindergartenAttendance_PaymentDate')} />
					<Field name='total' component={Input} type='text' disabled={isReadonly} label={t('KindergartenAttendance_MonthlyTotal')} validate={validators.number} />
					<Select name='isPaid' data={isPaidOptions(t)} disabled={isReadonly} hideEmptyOption={true} label={t('KindergartenAttendance_IsPaid')} />
				</Col>
				<Col sm={6}>
					<Field name='documentId' component={FormFileUpload} disabled={isReadonly} type='text' label={t('KindergartenAttendance_DocumentId')} initialData={documentData} />
				</Col>
			</Row>
			<FormActions>
				<Button type='submit' disabled={isReadonly || pristine || submitting} bsStyle='primary'>{t('Common_Save')}</Button>
			</FormActions>
		</Form>
	);
};

export default reduxForm({ form: 'kindergartenPaymentForm', enableReinitialize: true })(withTranslation()(SettingsForm));